import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Section text',
    defaultMessage: 'Text de secció',
  },
  text: {
    id: 'Section text content',
    defaultMessage: 'Text',
  },
});

export const SectionTextSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['text'],
    },
  ],
  properties: {
    text: {
      title: intl.formatMessage(messages.text),
      widget: 'textarea',
    },
  },
  required: ['text'],
});
